var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41844 13.8125L4.81313 7.4375L8.69125 10.8853C8.81268 10.9932 8.95724 11.0718 9.1138 11.1151C9.27036 11.1584 9.43477 11.1652 9.59437 11.135C9.75543 11.1048 9.90734 11.0378 10.0382 10.9392C10.1691 10.8406 10.2754 10.7131 10.3487 10.5666L13.2812 4.72812L12.3144 4.25L9.39781 10.0938L5.51969 6.64594C5.40133 6.53587 5.25942 6.45425 5.10476 6.4073C4.9501 6.36035 4.78676 6.3493 4.62719 6.375C4.4696 6.40115 4.31993 6.46249 4.18932 6.55447C4.05872 6.64644 3.95053 6.76669 3.87281 6.90625L1.0625 12.2188V0H0V13.8125C0 14.0943 0.111942 14.3645 0.311199 14.5638C0.510456 14.7631 0.780707 14.875 1.0625 14.875H14.875V13.8125H1.41844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.2e991cf41693bd421c154cfe7a26dc3f.svg";
export { ForwardRef as ReactComponent };